import { render, staticRenderFns } from "./ModulesSelect.vue?vue&type=template&id=0484728b&scoped=true"
import script from "./ModulesSelect.vue?vue&type=script&lang=js"
export * from "./ModulesSelect.vue?vue&type=script&lang=js"
import style0 from "./ModulesSelect.vue?vue&type=style&index=0&id=0484728b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484728b",
  null
  
)

export default component.exports